import React from "react";
import { Link } from "react-router-dom";
import { HomeIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";

function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4">
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary-600">404</h1>
          <div className="text-6xl mb-4">🔍</div>
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Sayfa Bulunamadı
        </h2>

        <p className="text-lg text-gray-600 mb-8 max-w-md">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir. Ana sayfaya
          dönün veya linklerinizi kontrol edin.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="btn btn-primary btn-lg">
            <HomeIcon className="w-5 h-5 mr-2" />
            Ana Sayfaya Dön
          </Link>

          <button
            onClick={() => window.history.back()}
            className="btn btn-secondary btn-lg"
          >
            <ArrowLeftIcon className="w-5 h-5 mr-2" />
            Geri Git
          </button>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500 mb-4">
            Sorun devam ediyorsa bizimle iletişime geçin:
          </p>
          <a
            href="mailto:support@kslnk.link"
            className="text-primary-600 hover:text-primary-700 font-medium"
          >
            support@kslnk.link
          </a>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
